import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { controlToastState, Modal } from "risa-oasis-ui_v2";
import { updateCigBoxNoteNewEndpoint } from "../../../api/postCall/updateCigBoxNote";
import {
  AllCommentsProps,
  BusniessOfficeNote,
} from "../../../data-model/busniessOfficeNote";
import { BusniessOfficeReportType } from "../../../enums/busniessOfficeReportType";
import { ModalId } from "../../../enums/modalId";
import { OrganizationType } from "../../../enums/organizationTypes";
import { createBusniessOfficePostNotes } from "../../../pages/singleOrderLayout/utils/createBusniessOfficeNoteData";
import { closeModal } from "../../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../../redux/store/store";
import { getOrgIdForFetchExternalWorklist } from "../../../utils/organizationHelper";
import BadgeWithIcon from "../../badgeWithIcon/badgeWithIcon";

interface RaiseQueryModalProps {
  onCommentsChange: (comment: string) => void;
  queryType?: string;
  reports?: BusniessOfficeNote[];
}

const RaiseQueryModal = (props: RaiseQueryModalProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const [queryType, setQueryType] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [writeBackReports, setWriteBackReports] = useState<AllCommentsProps>({
    comments: [],
    commentDate: "",
    type: BusniessOfficeReportType.FINAL,
  });
  const { singleMedicalPaOrder } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );

  useEffect(() => {
    if (props.reports && props.reports.length > 0) {
      const postReports = createBusniessOfficePostNotes(props.reports);
      setWriteBackReports(postReports);
    }
  }, [props.reports]);
  useEffect(() => {
    setQueryType(props.queryType || "");
  }, [props.queryType]);

  const orgId = getOrgIdForFetchExternalWorklist();

  const getInsuranceIssueTextForRadioButton = useMemo(() => {
    if (orgId === OrganizationType.CHC) {
      return "Authmate Issue";
    }
    return "Insurance Issue";
  }, [orgId]);

  const handleSave = async () => {
    setLoading(true);
    const notes = writeBackReports.comments.map((comment) => {
      return {
        note: queryType,
        report_status: getInsuranceIssueTextForRadioButton,
        report_identifier: comment.id,
      };
    });

    const payload = {
      patient_mrn: singleMedicalPaOrder?.payload?.patient_id ?? "",
      drug_name: singleMedicalPaOrder?.payload?.regimen_name ?? "",
      identifier: singleMedicalPaOrder?.id ?? "",
      write_back_reports: notes,
      org_id: getOrgIdForFetchExternalWorklist(),
      bo_status: getInsuranceIssueTextForRadioButton,
    };

    try {
      await Promise.race([
        updateCigBoxNoteNewEndpoint(payload),
        new Promise((resolve) =>
          setTimeout(() => resolve({ success: true }), 2000),
        ),
      ]);

      controlToastState("cig-box-note-updated-success");
      dispatch(closeModal());
    } catch (error) {
      console.error(error);
      controlToastState("cig-box-note-updated-failure");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      dialogId={ModalId.INSURANCE_ERROR_DIALOG}
      onSave={handleSave}
      onCancel={() => {
        dispatch(closeModal());
      }}
      onClose={() => {
        dispatch(closeModal());
      }}
      title="Trigger RPA"
      saveButtonText={"Trigger RPA"}
      disableSave={loading}
      cancelText="Cancel"
    >
      <div className="raise-query__container rounded-lg border border-primaryGray-14">
        <div className="raise-query__radio-btn flex items-center border-b border-primaryGray-14 p-2 text-h12">
          Radio Button :
          <div className="status ml-3">
            <BadgeWithIcon
              text={getInsuranceIssueTextForRadioButton}
              id={getInsuranceIssueTextForRadioButton}
              textColor="#0F0F0F"
              bgColor="#E5E5E5"
            />
          </div>
        </div>
        <div className="raise-query__comments p-2">
          <textarea
            className="h-48 w-full rounded-lg border border-none border-primaryGray-14 text-h12 outline-none"
            value={queryType}
            onChange={(e) => {
              setQueryType(e.target.value);
              props.onCommentsChange(e.target.value);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default RaiseQueryModal;
